import type { ExerciseAttempt } from 'api/rest/exerciseQueues/exerciseQueues.types';
import type { ExerciseAnswer } from 'api/rest/exercises/exercises.types';

/** Maps graded attempt metadata to exercise choices (supports multiple correct ids). */
export const resolveCorrectAnswers = (
  answers: ExerciseAnswer[],
  attempt: ExerciseAttempt,
  selectedAnswer: ExerciseAnswer | undefined,
): ExerciseAnswer[] => {
  if (!answers.length) {
    return [];
  }

  if (attempt.correctAnswerIds.length > 0) {
    const correctIds = new Set(attempt.correctAnswerIds);
    return answers.filter(answer => correctIds.has(answer.id));
  }

  if (attempt.correct) {
    const fallback = selectedAnswer ?? answers.find(answer => answer.label === attempt.answer);
    return fallback ? [fallback] : [];
  }

  return [];
};

export const formatAnswerLabels = (answers: ExerciseAnswer[]): string => answers.map(answer => answer.label).join(', ');
